import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { StoreCache } from '@/modules/cache/store'

const cache = new StoreCache('vehicle')

let res0, res1, res2, res3, res4, res5, res6, res7
const 
	p0 = new Promise(res => res0 = res), 
	p1 = new Promise(res => res1 = res),
	p2 = new Promise(res => res2 = res),
	p3 = new Promise(res => res3 = res),
	p4 = new Promise(res => res4 = res),
	p5 = new Promise(res => res5 = res),
	p6 = new Promise(res => res6 = res),
	p7 = new Promise(res => res7 = res)
	
export const storeReady = Promise.all([p0, p1, p2, p3, p4, p5, p6, p7])

export const useVehicleStore = defineStore('vehicles', () => {
	const tyreManufacturers = ref(null)
	const bodyBuilders = ref(null)
	const bodyStyles = ref(null)
	const cabTypes = ref(null)
	const classifications = ref(null)
	const vehicles = ref(null)
	const vehicle = ref(null)
	const features = ref(null)
	const grades = ref(null)
	const tyres = ref([
		'TyreNSF',
		'TyreNSR',
		'TyreOSF',
		'TyreOSR',
		'TyreSpare',
		'TyreNSI2',
		'TyreNSO2',
		'TyreOSI2',
		'TyreOSO2',
		'TyreNSI3',
		'TyreNSO3',
		'TyreOSI3',
		'TyreOSO3',
		'TyreNSI4',
		'TyreNSO4',
		'TyreOSI4',
		'TyreOSO4',
	])

	cache.get('allTyreManufacturers').then(val => {
		res0()
		if (val === null) return
		tyreManufacturers.value = val
	})

	cache.get('allVehicles').then(val => {
		res1()
		if (val === null) return
		vehicles.value = val
	})

	cache.get('allFeatures').then(val => {
		res2()
		if (val === null) return
		features.value = val
	})

	cache.get('allGrades').then(val => {
		res3()
		if (val === null) return
		grades.value = val
	})

	cache.get('allBodyBuilders').then(val => {
		res4()
		if (val === null) return
		bodyBuilders.value = val
	})

	cache.get('allBodyStyles').then(val => {
		res5()
		if (val === null) return
		bodyStyles.value = val
	})

	cache.get('allCabTypes').then(val => {
		res6()
		if (val === null) return
		cabTypes.value = val
	})

	cache.get('allClassifications').then(val => {
		res7()
		if (val === null) return
		classifications.value = val
	})

	const allTyreManufacturers = computed(() => tyreManufacturers.value)
	const allBodyBuilders = computed(() => bodyBuilders.value)
	const allBodyStyles = computed(() => bodyStyles.value)
	const allCabTypes = computed(() => cabTypes.value)
	const allClassifications = computed(() => classifications.value)
	const allVehicles = computed(() => vehicles.value)
	const currentVehicle = computed(() => vehicle.value)
	const allFeatures = computed(() => features.value)
	const allGrades = computed(() => grades.value)
	const tyreTypes = computed(() => tyres.value)

	function setTyreManufacturers(newManufacturers) {
		if (!(Array.isArray(newManufacturers) || typeof newManufacturers === 'object')) {
			return
		}

		cache.set(newManufacturers, 'allTyreManufacturers')
		tyreManufacturers.value = newManufacturers
	}

	function setBodyBuilders(newBodyBuilders) {
		if (!(Array.isArray(newBodyBuilders) || typeof newBodyBuilders === 'object')) {
			return
		}

		cache.set(newBodyBuilders, 'allBodyBuilders')
		bodyBuilders.value = newBodyBuilders
	}

	function setBodyStyles(newBodyStyles) {
		if (!(Array.isArray(newBodyStyles) || typeof newBodyStyles === 'object')) {
			return
		}

		cache.set(newBodyStyles, 'allBodyStyles')
		bodyStyles.value = newBodyStyles
	}

	function setCabTypes(newCabTypes) {
		if (!(Array.isArray(newCabTypes) || typeof newCabTypes === 'object')) {
			return
		}

		cache.set(newCabTypes, 'allCabTypes')
		cabTypes.value = newCabTypes
	}

	function setClassifications(newClassifications) {
		if (!(Array.isArray(newClassifications) || typeof newClassifications === 'object')) {
			return
		}

		cache.set(newClassifications, 'allClassifications')
		classifications.value = newClassifications
	}

	function setVehicles(newVehicles) {
		if (!(Array.isArray(newVehicles) || typeof newVehicles === 'object')) {
			return
		}

		cache.set(newVehicles, 'allVehicles')
		vehicles.value = newVehicles
	}
    
	function setCurrentVehicle(newVehicle) {
		if (typeof newVehicle !== 'object' && newVehicle !== null) {
			return
		}
        
		vehicle.value = newVehicle
	}

	function setFeatures(newFeatures) {
		if (!(Array.isArray(newFeatures) || typeof newFeatures === 'object')) {
			return
		}

		cache.set(newFeatures, 'allFeatures')
		features.value = newFeatures
	}

	function setGrades(newGrades) {
		if (typeof newGrades !== 'object' && newGrades !== null) {
			return
		}

		cache.set(newGrades, 'allGrades')
		grades.value = newGrades
	}

	return { 
		tyreManufacturers,
		bodyBuilders,
		bodyStyles,
		cabTypes,
		classifications,
		vehicles, 
		vehicle, 
		allTyreManufacturers,
		allBodyBuilders,
		allBodyStyles,
		allCabTypes,
		allClassifications,
		allVehicles,
		currentVehicle, 
		allFeatures,
		allGrades,
		tyreTypes,
		setTyreManufacturers,
		setBodyBuilders,
		setBodyStyles,
		setCabTypes,
		setClassifications,
		setVehicles, 
		setCurrentVehicle,
		setFeatures,
		setGrades,
	}
})